import React, { Component } from "react";
import styled from "styled-components";

const ListViewRowStyles = styled.div`
  .deal-item {
    color: white;
    position: relative;
    padding: 10px;

    .deal-expanded {
      opacity: 0;
      z-index: 0;
      margin-top: -10px;
      position: absolute;
      width: 100%;
      box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.75);
      transition: box-shadow 500ms cubic-bezier(0, 0.84, 0.67, 0.91);
      height: 100%;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        margin: 0px 15px;
        display: none;
        width: 200px;
        border: white solid 2px;
        padding: 25px 40px 40px 40px;
        border-radius: 15px;
        opacity: 0;
      }

      button {
        padding: 15px;
        width: auto;
        position: fixed;
        left: 50%;
        transform: translateX(-50%);
        bottom: 20px;
        top: initial;
        opacity: 0;
        transition: opacity 250ms ease-in-out 1000ms;
      }
    }

    .deal-details {
      opacity: 0;
      z-index: 0;
      width: calc(100% - 10px);
      position: absolute;
      left: 10px;
    }

    .deal-item-name {
      width: 80%;
      font-family: 'georgia';
      padding-bottom: 5px;
      font-size: 20px;
      line-height: 20px;
    }

    .deal-item-description {
      width: 70%;
      font-size: 12px;
    }

    button {
      margin: 0;
      border-radius: 10px;
      border: solid white 1px;
      background: none;
      position: absolute;
      color: white;
      right: 10px;
      top: 15px;
      bottom: 15px;
      width: 18%;
    }

    .use-button {
      opacity: 1;
      transition: opacity 500ms cubic-bezier(0, 0.84, 0.67, 0.91);
    }
  }

  .deal-item.expanded {
    .deal-details {
      z-index: 10;
      position: fixed;
      top: 25px;
      width: 100vw;
      text-align: center;
      opacity: 1;
      left: 0;

      .deal-item-name,
      .deal-item-description {
        width: fit-content;
        margin: auto;
      }
    }

    .deal-details.animate {
      transition: transform 500ms cubic-bezier(0.55, 0, 0.1, 1) 650ms;

      .deal-item-name,
      .deal-item-description {
        transition: transform 500ms cubic-bezier(0.55, 0, 0.1, 1);
      }
    }

    .deal-expanded {
      margin-top: 0;
      z-index: 10;
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      text-align: center;
      box-shadow: 10px 50px 150px rgba(0, 0, 0, 0.3);
      transition: box-shadow 1000ms cubic-bezier(0, 0.84, 0.67, 0.91);
      background-color: ${props => props.baseColor};
      height: 100%;
      opacity: 1;

      img {
        display: block;
        transition: opacity 500ms ease-in-out 1300ms;
      }
    }

    .deal-expanded.animate {
      transition: transform 500ms cubic-bezier(0, 0.84, 0.67, 0.91) 500ms,
        box-shadow 1000ms cubic-bezier(0, 0.84, 0.67, 0.91),
        background-color 1000ms ease-in-out;
    }
  }
`;

export default class ListViewRow extends Component {
  constructor(props) {
    super(props);

    this.expand = this.expand.bind(this);
    this.collapse = this.collapse.bind(this);
  }

  collapse() {
    const el = this.dealItem;
    var expanded = el.querySelector(".deal-expanded");
    var details = el.querySelector(".deal-details");
    var nameEl = details.querySelector(".deal-item-name");
    var descEl = details.querySelector(".deal-item-description");
    var img = expanded.querySelector("img");
    var button = expanded.querySelector("button");

    img.style.transitionDelay = "0ms";
    button.style.transitionDelay = "0ms";
    img.style.opacity = "";

    function onAnimationEnd(evt) {
      // dont fire for the image
      if (
        evt.srcElement.tagName === "IMG" ||
        evt.srcElement.tagName === "BUTTON"
      )
        return;

      expanded.removeEventListener("transitionend", onAnimationEnd);
      el.classList.remove("expanded");

      expanded.style.transform = "";
      expanded.style.background = "";
      expanded.style.opacity = "";
      expanded.style.backgroundColor = "";
      details.style.transform = "";
      nameEl.style.transform = "";
      descEl.style.transform = "";

      nameEl.style.transitionDelay = "";
      descEl.style.transitionDelay = "";
      details.style.transitionDelay = "";
      button.style.transitionDelay = "";
      img.style.transitionDelay = "";

      expanded.classList.remove("animate");
      details.classList.remove("animate");

      var useButton = el.querySelector("button.use-button");
      useButton.style.position = "";
      useButton.style.zIndex = "";
      useButton.style.top = "";
      useButton.style.right = "";
      useButton.style.opacity = "";
    }
    expanded.addEventListener("transitionend", onAnimationEnd, false);

    nameEl.style.transitionDelay = "500ms";
    descEl.style.transitionDelay = "500ms";
    details.style.transitionDelay = "250ms";

    var bcr = el.getBoundingClientRect();
    var expandedFirst = expanded.getBoundingClientRect();
    var detailsFirst = details.getBoundingClientRect();
    var nameFirst = nameEl.getBoundingClientRect();
    var descFirst = descEl.getBoundingClientRect();

    function onButtonTransitionEnd(evt) {
      button.removeEventListener("transitionend", onButtonTransitionEnd);
      var viewportHeight = document.body.getBoundingClientRect().height;
      var expandedOffset =
        -1 * (viewportHeight * (1 - bcr.height / expandedFirst.height) * 0.5);

      window.requestAnimationFrame(function() {
        expanded.style.transform = `translateY(${expandedOffset +
          bcr.top}px) scaleY(${bcr.height / expandedFirst.height})`;
        expanded.style.backgroundColor = el.style.backgroundColor;

        details.style.transform = `translateY(${bcr.top +
          10 -
          detailsFirst.top}px)`;
        nameEl.style.transform = `translateX(${bcr.left +
          10 -
          nameFirst.left}px)`;
        descEl.style.transform = `translateX(${bcr.left +
          10 -
          descFirst.left}px)`;
      });
    }

    button.addEventListener("transitionend", onButtonTransitionEnd);
    button.style.opacity = "";
  }

  expand() {
    window.ga && window.ga("send", "event", "Use Deal", this.props.item.name);
    this.props.useDeal();

    const el = this.dealItem;
    var expanded = el.querySelector(".deal-expanded");
    var details = el.querySelector(".deal-details");
    var nameEl = details.querySelector(".deal-item-name");
    var descEl = details.querySelector(".deal-item-description");
    var img = expanded.querySelector("img");
    var button = expanded.querySelector("button");

    var useButton = el.querySelector("button.use-button");
    var useButtonBcr = useButton.getBoundingClientRect();
    useButton.style.position = "absolute";
    useButton.style.zIndex = 10;
    useButton.style.top = useButtonBcr.top;
    useButton.style.right = useButtonBcr.right;
    useButton.style.opacity = 0;

    var expandedFirst = expanded.getBoundingClientRect();
    var detailsFirst = details.getBoundingClientRect();
    var nameFirst = nameEl.getBoundingClientRect();
    var descFirst = descEl.getBoundingClientRect();

    window.requestAnimationFrame(function() {
      el.classList.add("expanded");
      var expandedLast = expanded.getBoundingClientRect();
      var detailsLast = details.getBoundingClientRect();
      var nameLast = nameEl.getBoundingClientRect();
      var descLast = descEl.getBoundingClientRect();

      // The height of the window - whats left after scale down and then divide by two because above and below
      var viewportHeight = document.body.getBoundingClientRect().height;
      var expandedOffset =
        -1 *
        (viewportHeight *
          (1 - expandedFirst.height / expandedLast.height) *
          0.5);

      expanded.style.backgroundColor = el.style.backgroundColor;
      expanded.style.transform = `translateY(${expandedOffset +
        expandedFirst.top}px) scaleY(${expandedFirst.height /
        expandedLast.height})`;
      expanded.style.opacity = 0;
      details.style.transform = `translateY(${detailsFirst.top -
        detailsLast.top}px)`;
      nameEl.style.transform = `translateX(${nameFirst.left -
        nameLast.left}px)`;
      descEl.style.transform = `translateX(${descFirst.left -
        descLast.left}px)`;

      window.requestAnimationFrame(function() {
        expanded.classList.add("animate");
        details.classList.add("animate");
        window.requestAnimationFrame(function() {
          button.style.opacity = 1;
          img.style.opacity = 1;
          expanded.style.transform = "";
          expanded.style.background = "";
          expanded.style.opacity = "";
          expanded.style.backgroundColor = "";
          details.style.transform = "";
          nameEl.style.transform = "";
          descEl.style.transform = "";
        });
      });
    });
  }

  render() {
    const { item, color, baseColor, card } = this.props;
    return (
      <ListViewRowStyles baseColor={baseColor}>
        <div
          ref={el => (this.dealItem = el)}
          className="deal-item"
          style={{
            backgroundColor: color
          }}
        >
          <div className="deal-expanded">
            <img src={card} alt="Card Logo" />
            <button onClick={this.collapse}>Close</button>
          </div>
          <div className="deal-details">
            <div className="deal-item-name">
              {item.name}
            </div>
            <div className="deal-item-description">
              {item.description}
            </div>
          </div>
          <div className="deal-item-name">
            {item.name}
          </div>
          <div className="deal-item-description">
            {item.description}
          </div>
          <button className="use-button" onClick={this.expand}>
            Use
          </button>
        </div>
      </ListViewRowStyles>
    );
  }
}



// WEBPACK FOOTER //
// ./src/user/ListViewRow.js